<article class="item cursor-pointer bg-light-green research-impact-carousel" [style]="styles">
  <img class="dna" src="assets/images/svg/dna.svg">
  <div class="left-side">
    <img class="brain" src="assets/images/svg/brain.svg">
    <img class="network" src="assets/images/svg/network.svg">
  </div>
  <div class="text-overlay">
    <span class="slide-title">{{ noKpiProject.additional_data_top[currentLanguage] }}</span>
    <span class="slide-value"> {{ noKpiProject.additional_data_middle }}</span>
    <img class="brain-mobile" src="assets/images/svg/brain.svg">
    <span class="slide-subtitle"> {{ noKpiProject.additional_data_bottom[currentLanguage] }}</span>
  </div>
</article>
